import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=dcab801c"
var script = {}
import style0 from "./Documentation.vue?vue&type=style&index=0&id=dcab801c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports